import React, { FC } from 'react';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';

import { getAppImage } from 'helpers';
import { APP_IMAGES } from 'constants/index';

const styles = (theme: Theme) =>
  createStyles({
    logo: {
      marginBottom: theme.spacing(3),

      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(3),
      },
    },
  });

interface IProps extends WithStyles<typeof styles> {}

const Logo: FC<IProps> = ({ classes }) => (
  <div className={classes.logo}>
    <img {...getAppImage(APP_IMAGES.Logo)} />
  </div>
);

export default withStyles(styles)(Logo);
